import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CalcConfigService } from '_services/calc-config.service';
import { SelectorsService } from '_services/selectors.service';
import { MatrixAxis, Table } from '../../_models/table';
import { HelpComponent } from '../../_shared/help/help.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AidYearComponent } from '../../_shared/aid-year/aid-year.component';
import { MatCard } from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
import { UsageComponent } from '../usage/usage.component';
import { KeyboardScrollableDirective } from '../../_shared/directives/keyboard-scrollable.directive';

@Component({
    selector: 'app-tables',
    templateUrl: './tables.component.html',
    styleUrls: ['./tables.component.css'],
    imports: [HelpComponent, MatButton, MatIcon, AidYearComponent, MatCard, UsageComponent, AsyncPipe, KeyboardScrollableDirective]
})
export class TablesComponent {
  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    public cc: CalcConfigService,
    private ss: SelectorsService
  ) {
    this.titleService.setTitle('Tables' + ' | NPC Admin');
  }

  getSelectorName(id?: string): string {
    if (!id) {
      return '';
    }
    const selector = this.ss.getSelector(id);
    return selector ? selector.label : '';
  }

  matrixTableSummary(table: Table): string {
    const mt = table.matrixTable;
    if (!mt) {
      return '';
    }
    return `Matrix — Rows: ${this.axisSummary(mt.rows)}; Columns: ${this.axisSummary(mt.columns)}`;
  }

  private axisSummary(axis: MatrixAxis): string {
    if (axis.formulaId) {
      return this.cc.getFormula(axis.formulaId)?.name ?? axis.formulaId;
    }
    if (axis.keyId) {
      return this.getSelectorName(axis.keyId);
    }
    return '(unset)';
  }

  openTable(table: Table) {
    this.router.navigate([table.tableId], { relativeTo: this.route });
  }

  createTable() {
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  activateTable(event: Event, table: Table) {
    event.preventDefault();
    event.stopPropagation();
    this.openTable(table);
  }

  trackByTableId(index: number, table: Table) {
    return table.tableId;
  }
}
